import { animate, createScope } from 'animejs';
import { useEffect, useRef, React } from 'react';
import Navbar2 from "../Components/Navbar2";
import Footer from "../Components/Footer";
import FeatureCard from "../Components/FeatureCard";

function Foundation() {

  const scope = useRef(null);
  const display4 = useRef(null);
  
    useEffect(() => {
    
      scope.current = createScope({ display4 }).add( self => {
  
        // Created a sliding animation
        animate('.display-4', 
          { translateX: [-1200, 0],
            opacity: [1, 0.5, 1],
            easing: 'easeOutExpo',
          });

      });
  
      // Properly cleanup all anime.js instances declared inside the scope
      return () => scope.current.revert()
  
    }, []);

  return (
    <>
      <Navbar2 />
      <div className="container-fluid pt-3">
        <div className="row text-center">
          <div className="col pt-3 ps-5 pe-5">
            <div className="h1">
              TIM PORTER FOUNDATION
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-md-3 d-flex align-items-end">
            <img src="./s3/tim_porter.png"
              className="img img-fluid"
              alt=""
            />
          </div> */}
          <div className="col-md-12">
            <div className="bebas-neue-regular display-4 p-5">
              The Timothy Porter Foundation provides scholarships for
              underserved youth to access sports, emotional wellness, and leadership programs.
            </div>
          </div>
        </div>
      </div>
        {/* <div className="red-block">
        </div> */}
      <div className="container-fluid pt-3">
        <div className="row text-center">
          <div className="col pt-3 ps-5 pe-5">
            <div className="h1 pb-3">
              PROGRAMS &amp; SCHOLARSHIPS
            </div>
          </div>
        </div>
        <div className="row row-cols-1 row-cols-md-3 rows-col-lg-3 g-3 pb-5">
          <div className="col-md-6 col-sm-12">
            <FeatureCard
            title="Sports Access"
            backgroundImage="./s3/foundation_sportsaccess.jpg"
            buttonText="Coming Soon"
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <FeatureCard 
              backgroundImage="./s3/foundation_wellness.jpg"
              title="EMOTIONAL WELLNESS &amp; LEADERSHIP"
              buttonText="Coming Soon"
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <FeatureCard 
              backgroundImage="./s3/foundation_howscholarship.jpg"
              title="How Scholarships Work"
              buttonText="Coming Soon"
            />
          </div>
          <div className="col-md-6 col-sm-12">
            <FeatureCard 
              backgroundImage="./s3/foundation_applyscholarship.jpg"
              title="Apply for a Scholarship"
              buttonText="Coming Soon"
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Foundation;
